function updatePuroteShippingBar() {
  fetch('/cart.js')
    .then(function(response) {
      return response.json();
    })
    .then(function(cart) {

      // Productos que tienen envío gratis automáticamente
      const freeShippingProducts = [
        'pack-de-iniciacion'
      ];

      // Comprueba si alguno está en el carrito
      const hasFreeShippingProduct = cart.items.some(function(item) {
        return freeShippingProducts.includes(item.handle);
      });

      document.querySelectorAll('.purote-shipping-bar').forEach(function(bar) {

        const threshold = parseInt(
          bar.dataset.freeShippingThreshold || '3000',
          10
        );

        const remaining = threshold - cart.total_price;

        const text = bar.querySelector('.purote-shipping-bar__text');
        const fill = bar.querySelector('.purote-shipping-bar__fill');

        if (!text || !fill) return;

        // PACK CON ENVÍO GRATIS
        if (hasFreeShippingProduct) {

          text.innerHTML = '✓ ¡Tu pedido tiene envío gratis!';
          fill.style.width = '100%';
          bar.classList.add('purote-shipping-bar--success');

          return;
        }

        // CARRITO NORMAL DE 30 € O MÁS
        if (remaining <= 0) {

          text.innerHTML = '✓ ¡Ya tienes envío gratis!';
          fill.style.width = '100%';
          bar.classList.add('purote-shipping-bar--success');

          return;
        }

        // TODAVÍA NO HA LLEGADO A 30 €
        const progress = Math.min(
          (cart.total_price / threshold) * 100,
          100
        );

        const formattedRemaining = new Intl.NumberFormat('es-ES', {
          style: 'currency',
          currency: 'EUR'
        }).format(remaining / 100);

        text.innerHTML =
          'Te faltan <strong>' +
          formattedRemaining +
          '</strong> para conseguir envío gratis';

        fill.style.width = progress + '%';
        bar.classList.remove('purote-shipping-bar--success');
      });
    })
    .catch(function(error) {
      console.error('Puro Té: error actualizando envío gratis', error);
    });
}

document.addEventListener('DOMContentLoaded', function() {
  updatePuroteShippingBar();
});

document.addEventListener('change', function(event) {
  if (
    event.target.matches('input[name="updates[]"]') ||
    event.target.closest('quantity-input')
  ) {
    setTimeout(updatePuroteShippingBar, 800);
  }
});

document.addEventListener('click', function(event) {
  if (
    event.target.closest('button[name="add"]') ||
    event.target.closest('.quantity__button') ||
    event.target.closest('cart-remove-button')
  ) {
    setTimeout(updatePuroteShippingBar, 800);
  }
});

/* ==========================================
   PURO TÉ - CROSS SELL
   ========================================== */

document.addEventListener('click', async function(event) {
  const button = event.target.closest('.purote-cross-sell__button');

  if (!button) return;

  event.preventDefault();

  const container = button.closest('.purote-cross-sell__form');
  const variant = container.querySelector('.purote-cross-sell__variant');

  if (!variant || !variant.value) {
    console.error('Puro Té: no se encontró la variante');
    return;
  }

  const variantId = Number(variant.value);
  const originalText = button.textContent;

  button.disabled = true;
  button.textContent = 'Añadiendo...';

  try {

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data.description ||
        data.message ||
        'No se ha podido añadir el producto'
      );
    }

    window.location.reload();

  } catch (error) {

    console.error('Puro Té - Cross sell:', error);

    button.disabled = false;
    button.textContent = originalText;

    alert(error.message);
  }
});